import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const rdManagerRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/RD-Manager/rd-dashboard/rd-dashboard').then(
        (m) => m.RdDashboard
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'RD Manager',
    },
  },
  {
    path: 'project-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/RD-Manager/project-management/project-management').then(
        (m) => m.ProjectManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'RD Manager',
    },
  },
  {
    path: 'project-management/add-project',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/RD-Manager/project-management/add-project/add-project'
      ).then((m) => m.AddProject),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'RD Manager',
    },
  },
  {
    path: 'project-management/add-project/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/RD-Manager/project-management/add-project/add-project'
      ).then((m) => m.AddProject),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'RD Manager',
    },
  },
  {
    path: 'project-management/details/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/RD-Manager/project-management/project-details/project-details'
      ).then((m) => m.ProjectDetails),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'RD Manager',
    },
  },
  // {
  //     path: 'training-center',
  //     loadComponent: () => import('@pages/RD-Manager/training-center/training-center').then(m => m.TrainingCenter),
  //     data: {
  //         isSidebar: 1,
  //         isHeader: 1,
  //     },
  //     children: [
  //         {
  //             path: '',
  //             loadComponent: () => import('@pages/RD-Manager/training-center/training-home/training-home').then(m => m.TrainingHome),
  //         },
  //         {
  //             path: 'allVideos',
  //             loadComponent: () => import('@pages/RD-Manager/training-center/all-videos/all-videos').then(m => m.AllVideos),
  //         },
  //         {
  //             path: 'allDocs',
  //             loadComponent: () => import('@pages/RD-Manager/training-center/all-docs/all-docs').then(m => m.AllDocs),
  //         }
  //     ]
  // },
  // {
  //     path: 'training-center/video/:id',
  //     loadComponent: () =>
  //         import('@pages/RD-Manager/training-center/training-vid/training-vid').then(m => m.TrainingVid),
  //     data: {
  //         isSidebar: 1,
  //         isHeader: 1,
  //     }
  // },
];
